export default __webpack_public_path__ + "static/media/NFT.ea1dc727.png";